import { addItemToCart } from '@umbrella/cart-service';

class RCQuickCheckout extends HTMLElement {

  constructor(){
    super();
    this.form = null;
    this.button = null;
    this.variantInput = null;
    this.handleClick = this.handleClick.bind(this);
    this.updateDisabledState = this.updateDisabledState.bind(this);
    this._onCartState = () => { setTimeout(this.updateDisabledState, 0); };
    this._onVariantChange = this.updateDisabledState;
    this._qtyObserver = null;
    this._defaultTextEl = null;
    this._disabledTextEl = null;
  };

  connectedCallback(){
    this.form = this.closest('form');
    if(!this.form) return;
    this.button = this.querySelector('button');
    if(!this.button) return;
    this.variantInput = this.form.querySelector('input[name="id"]');
    this._defaultTextEl = this.button.querySelector('[data-default-text]');
    this._disabledTextEl = this.button.querySelector('[disabled-text]');
    this.button.addEventListener('click', this.handleClick);
    document.addEventListener('cart:state', this._onCartState);
    const ev = (window.umbrellaConfig && window.umbrellaConfig.events && window.umbrellaConfig.events.variantChange) || 'variant:change';
    document.addEventListener(ev, this._onVariantChange);
    const qtyInput = this.form.querySelector('input[name="quantity"]');
    if(qtyInput && window.MutationObserver){
      this._qtyObserver = new MutationObserver(() => { this.updateDisabledState(); });
      this._qtyObserver.observe(qtyInput, { attributes: true, attributeFilter: ['max','disabled','value'] });
      const qtyWrapper = this.form.querySelector('rc-quantity-input');
      if(qtyWrapper) qtyWrapper.addEventListener('quantity-change', this.updateDisabledState);
    };
    this.updateDisabledState();
  };

  disconnectedCallback(){
    if(this.button) this.button.removeEventListener('click', this.handleClick);
    document.removeEventListener('cart:state', this._onCartState);
    const ev = (window.umbrellaConfig && window.umbrellaConfig.events && window.umbrellaConfig.events.variantChange) || 'variant:change';
    document.removeEventListener(ev, this._onVariantChange);
    if(this._qtyObserver){ try { this._qtyObserver.disconnect(); } catch(e){} this._qtyObserver = null; }
    const qtyWrapper = this.form && this.form.querySelector && this.form.querySelector('rc-quantity-input');
    if(qtyWrapper){ qtyWrapper.removeEventListener('quantity-change', this.updateDisabledState); }
  };

  updateDisabledState(){
    if(!this.button) return;
    const qtyInput = this.form && this.form.querySelector('input[name="quantity"]');
    const qtyWrapper = this.form && this.form.querySelector('rc-quantity-input');
    const continueSelling = !!(qtyWrapper && qtyWrapper.hasAttribute('continue-selling'));
    if(qtyInput && qtyInput.disabled){
      this.button.disabled = true;
      this._showDisabled('Out of stock');
      return;
    };
    if(continueSelling){
      this.button.disabled = false;
      this._showDefault('Buy it now');
      return;
    };
    const min = qtyInput && qtyInput.getAttribute('min') !== null ? Number(qtyInput.getAttribute('min')) : 1;
    const maxAttr = qtyInput && qtyInput.getAttribute('max');
    const max = maxAttr ? Number(maxAttr) : Infinity;
    const disable = Number.isFinite(max) ? (max <= 0 || max < min) : false;
    this.button.disabled = !!disable;
    if(disable){ this._showDisabled('Out of stock'); } else { this._showDefault('Buy it now'); }
  };

  _showDefault(text){
    if(this._defaultTextEl){ this._defaultTextEl.textContent = text; this._defaultTextEl.classList.remove('hidden'); }
    if(this._disabledTextEl){ this._disabledTextEl.classList.add('hidden'); }
  };

  _showDisabled(text){
    if(this._disabledTextEl){ this._disabledTextEl.textContent = text; this._disabledTextEl.classList.remove('hidden'); }
    if(this._defaultTextEl){ this._defaultTextEl.classList.add('hidden'); }
  };

  async handleClick(e){
    e.preventDefault();
    if(this.button && this.button.disabled) return;
    if(!this.form || !this.variantInput) return;
    const variantId = this.variantInput.value;
    if(!variantId) return;
    const quantityInput = this.form.querySelector('input[name="quantity"]');
    let quantity = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
    // Clamp based on remaining
    const qtyMaxAttr = quantityInput && quantityInput.getAttribute('max');
    const initialMax = qtyMaxAttr ? Number(qtyMaxAttr) : Infinity;
    const continueSelling = !!(this.form.querySelector('rc-quantity-input[continue-selling]'));
    if(!continueSelling && Number.isFinite(initialMax)){
      const inCart = (window.umbrellaConfig && typeof window.umbrellaConfig.getInCartQty === 'function')
        ? window.umbrellaConfig.getInCartQty(variantId)
        : 0;
      const remaining = Math.max(0, initialMax - inCart);
      if(remaining <= 0){
        const showToast = (window.umbrellaConfig && window.umbrellaConfig.showToast) || window.showToast;
        if(showToast) showToast(`Requested ${quantity} exceeds available stock of ${remaining}.`, 'error', true, 4000);
        return;
      };
      if(quantity > remaining){
        quantity = remaining;
        if(quantityInput) quantityInput.value = String(quantity);
        const showToast = (window.umbrellaConfig && window.umbrellaConfig.showToast) || window.showToast;
        if(showToast) showToast(`Only ${remaining} available; adding ${remaining}.`, 'warning', true, 4000);
      };
    };
    try {
      this.button.disabled = true;
      this._showDisabled('Checking out...');
      await addItemToCart(variantId, quantity, new FormData(this.form));
      // Redirect to checkout
      window.location.href = '/checkout';
    } catch(err){
      console.error('Quick checkout failed', err);
      const showToast = (window.umbrellaConfig && window.umbrellaConfig.showToast) || window.showToast;
      if(showToast) showToast(err.message || 'Failed to add item to cart. Please try again.', 'error', true, 4000);
      this.button.disabled = false;
      this.updateDisabledState();
    };
  };

};

if(!customElements.get('rc-quick-checkout')){
  customElements.define('rc-quick-checkout', RCQuickCheckout);
};